import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { getMessage, getNumMessages, lobbyMessageEnum } from './roomSlice';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import classNames from "classnames";
import ScrollToBottom from '../../components/ScrollToBottom';
import { ChatSubmit } from '../../components/ChatSubmit';

import './Chat.css';

const Message = (props) => {
  const { t } = useTranslation();
  const args = props.args ?? {};

  switch (props.type) {
    case lobbyMessageEnum.ROLLED: {
      return (
        <Trans t={t} i18nKey="LOBBY_MESSAGE.ROLLED">
          <span className="player">{{player: args.name}}</span> har rullat <span className="word">{{word: args.word}}</span> ({{points: args.points}})!
        </Trans>
      );
    }
    case lobbyMessageEnum.MESSAGE: {
      return (
        <Trans t={t} i18nKey="LOBBY_MESSAGE.MESSAGE">
          <span className="player">{{player: args.name}}</span>: {{data: args.data}}
        </Trans>
      );
    }
    case lobbyMessageEnum.RESTART_IN_PROGRESS: {
      return (
        <Trans t={t} i18nKey="LOBBY_MESSAGE.RESTART_IN_PROGRESS">
          Detta spelrum skall gå ned för uppgradering, du kan därför inte skapa några nya spel. V.g. försök i ett annat spelrum.
        </Trans>
      );
    }
    case lobbyMessageEnum.INVITE: {
      return (
        <Trans t={t} i18nKey="LOBBY_MESSAGE.INVITE">
          Inbjudan skickad till <span className="player">{{player: args.name}}</span>.
        </Trans>
      );
    }
    case lobbyMessageEnum.INVITED: {
      return (
        <Trans t={t} i18nKey="LOBBY_MESSAGE.INVITED">
          Du har blivit inbjuden till ett spel av <span className="player">{{player: args.name}}</span>.
        </Trans>
      );
    }
    case lobbyMessageEnum.ALREADY_INVITED: {
      return (
        <Trans t={t} i18nKey="LOBBY_MESSAGE.ALREADY_INVITED">
          Du har redan bjudit in denna spelare.
        </Trans>
      );
    }
    default: {
      throw Error('Unknown lobbyMessageEnum '+ props.type);
    }
  }
}

const MessageWrapper = (props) => {
  const msg = useSelector(state => getMessage(state, props.id), shallowEqual);
  const cls = classNames({
    'auto': msg.type !== lobbyMessageEnum.MESSAGE,
    'invite': msg.type === lobbyMessageEnum.INVITE || msg.type === lobbyMessageEnum.INVITED,
    'message': msg.type === lobbyMessageEnum.MESSAGE,
  })
  return (
    <div className={cls}>{msg.type !== lobbyMessageEnum.MESSAGE ? "» " : ""}<Message type={msg.type} args={msg.args}/></div>
  );
}

const Messages = () => {
  const num = useSelector(getNumMessages);
  return (
    <ScrollToBottom className="messages box">
      {[...Array(num).keys()].map(id => (
        <MessageWrapper key={id} id={id}/>
      ))}
    </ScrollToBottom>
  );
};

export const Chat = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  return (
    <>
      <h2>{t("CHAT")}</h2>
      <Messages/>
      <ChatSubmit onSubmit={msg => dispatch({ type: 'action/message', payload: {dest: 'LOBBY', data: msg} })} />
    </>
  );
};